// This file was automatically generated from passwordQA.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.passwordQA');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.passwordQA.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><h3 class="el8BrandColor el8LightWeight el8AlignCenter">Verify your identity</h3><div class="el8LgSpacer"></div><p class="el8AlignCenter el8Gray">Answer your security question:</p><h4 class="el8AlignCenter mbMd">', soy.$$escapeHtml(opt_data.question), '</h4><div class="w60p el8CenterBlock"><div class="el8ErrorAlert incorrect-answer">Incorrect answer</div><div class="el8FormSolo"><form id="main-form"><input type="text" name="answer" class="el8StandardInput" placeholder="Answer..."></input></form></div><div class="el8MdSpacer"></div><button id="submit" class="el8Btn el8BtnBlock el8BtnPrimary">Submit</button><p class="mtMd el8AlignCenter"><a href="', soy.$$escapeHtml(opt_data.forgotAnswerUrl), '">I don\'t know the answer.</a></p></div><div class="el8XLSpacer"></div></div></div>');
  if (!opt_sb) return output.toString();
};
